export class ErrorState {

}
